import request from './request.js';
import {requestbody} from './request.js'

export async function landinit(params = {

}) {
    return await requestbody('/land/init', 'post', params)
}
export async function detailimport(params = {

}) {
    return await requestbody('/land/detail/import', 'post', params)
}

//分页查询
export async function landquery(params = {

}) {
    return await requestbody('/land/query', 'post', params)
}
//清空数据
export async function dateclear(params = {

}) {
    return await requestbody('/land/date/clear', 'post', params)
}

//城镇土地使用税明细
export async function cztdquery(params = {

}) {
    return await requestbody('/land/detail/cztd/query', 'post', params)
}

//获取纳税人识别号list
export async function queryNsrinfo(params = {

}) {
    return await requestbody('sys/queryNsrinfo', 'post', params)
}
//
export async function listexport(params = {

}) {
    return await requestbody('/land/list/export', 'post', params)
}

//新增
export async function detailcztdadd(params = {

}) {
    return await requestbody('/land/detail/cztd/add', 'post', params)
}
//查询单挑详情
export async function cztdsingleQuery(params = {

}) {
    return await request('/land/detail/cztd/singleQuery', 'post', params)
}
//土地总体信息表分页查询
export async function detailsingleQuery(params = {

}) {
    return await request('/tudztxx/page', 'get', params)
}
export async function cztdupdate(params = {
//修改
}) {
    return await requestbody('/land/detail/cztd/update', 'post', params)
}
export async function cztdclear(params = {
//删除
}) {
    return await requestbody('/land/detail/cztd/clear', 'post', params)
}
export async function tudztxxsave(params = {
//新增土地总体信息表操作
}) {
    return await requestbody('/tudztxx/save', 'post', params)
}
export async function tudztxxupdate(params = {
//修改土地总体信息表操作
}) {
    return await requestbody('/tudztxx/update', 'post', params)
}
export async function tudztxxdelete(params = {
//删除土地总体信息表操作
}) {
    return await request('/tudztxx/delete', 'post', params)
}

//从价修改
export async function cjjzadd(params = {
	
}) {
    return await requestbody('/land/detail/cjjz/add', 'post', params)
}
//列表
export async function cjjzquery(params = {
	
}) {
    return await requestbody('/land/detail/cjjz/query', 'post', params)
}
//详情
export async function fangwxxpage(params = {
	
}) {
    return await requestbody('/fangwxx/page', 'get', params)
}
//修改从价
export async function cjjzsingleQuery(params = {
	
}) {
    return await request('/land/detail/cjjz/singleQuery', 'post', params)
}
//删除从价
export async function cjjzclear(params = {
	
}) {
    return await requestbody('/land/detail/cjjz/clear', 'post', params)
}

//分页从组
export async function czjzquery(params = {
	
}) {
    return await requestbody('/land/detail/czjz/query', 'post', params)
}
//新增从组
export async function czjzadd(params = {
	
}) {
    return await requestbody('/land/detail/czjz/add', 'post', params)
}
//编辑从组
export async function cjjzupdate(params = {
	
}) {
    return await requestbody('/land/detail/cjjz/update', 'post', params)
}
export async function czjzupdate(params = {
	
}) {
    return await requestbody('/land/detail/czjz/update', 'post', params)
}

//查询从组
export async function czjzsingleQuery(params = {
	
}) {
    return await request('/land/detail/czjz/singleQuery', 'post', params)
}
//删除从组
export async function czjzclear(params = {
	
}) {
    return await requestbody('/land/detail/czjz/clear', 'post', params)
}
// 新增
export async function fangwxxsave(params = {
	
}) {
    return await requestbody('fangwxx/save', 'post', params)
}
//修改
export async function fangwxxupdate(params = {
	
}) {
    return await requestbody('/fangwxx/update', 'post', params)
}
//删除
export async function fangwxxdelete(params = {
	
}) {
    return await request('/fangwxx/delete', 'post', params)
}
//所属期查询
export async function queryByCompanyFcTdShenb(params = {
	
}) {
    return await request('/sys/queryByCompanyFcTdShenb', 'post', params)
}
//查询公司
export async function queryCompanyNo(params = {

}) {
    return await request('/land/queryCompanyNo', 'get', params)
}

//查询公司
export async function startTaxGather(params = {

}) {
    return await request('/land/startTaxGather', 'post', params)
}
